import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Success() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4 py-12">
      <div className="max-w-xl w-full text-center space-y-8">
        {/* ✅ ICONO DE ÉXITO */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: "spring", stiffness: 300, damping: 20 }}
          className="flex justify-center"
        >
          <div className="bg-yellow-100 p-4 rounded-full shadow-md">
            <CheckCircle className="h-12 w-12 text-yellow-600" />
          </div>
        </motion.div>

        {/* ✅ TITULAR */}
        <motion.h1
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="text-2xl sm:text-3xl font-bold text-gray-900"
        >
          ¡Bienvenido/a a Noltrade Premium!
        </motion.h1>

        {/* ✅ SUBTÍTULO */}
        <p className="text-gray-600 text-sm sm:text-base max-w-md mx-auto">
          Tu suscripción se ha activado correctamente. Ya puedes acceder a todos los detalles, iniciar chats con fundadores y descubrir oportunidades exclusivas.
        </p>

        {/* ✅ TARJETA DESTACADA */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-yellow-50 border border-yellow-200 rounded-xl p-6 text-left shadow-sm space-y-4"
        >
          <h3 className="text-lg font-semibold text-yellow-800">¿Qué puedes hacer ahora?</h3>
          <ul className="list-disc list-inside text-sm text-yellow-900 space-y-1">
            <li>Acceso completo a todos los listados</li>
            <li>Ver compradores y contactar sin límites</li>
            <li>Acceso prioritario a oportunidades</li>
            <li>Dashboard privado</li>
            <li>Informes de ofertas</li>
            <li>Histórico financiero</li>
            <li>Posibilidad de solicitar reuniones privadas con el vendedor</li>
            <li>Activos clave y contratos</li>
          </ul>
        </motion.div>

        {/* ✅ CTA */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <Link
            to="/ofertas"
            className="inline-block bg-yellow-600 hover:bg-yellow-700 text-white text-sm font-medium px-6 py-2 rounded-md shadow transition"
          >
            Explorar oportunidades →
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
